import { Helmet } from "react-helmet-async";
import LegalDoc from "@/components/LegalDoc";

const PrivacyPolicy = () => (
  <>
    <Helmet>
      <title>Privacy Policy | Zentra</title>
      <meta
        name="description"
        content="How Zentra (Mountain Fresh Farms LLP) collects, uses and protects your personal information when you shop or contact us."
      />
    </Helmet>
    <LegalDoc
      testId="privacy-policy-page"
      title="Privacy Policy"
      updated="July 2026"
      intro="This Privacy Policy describes how Mountain Fresh Farms LLP (brand: ZENTRA, “we”, “us”, “our”), Coimbatore, Tamil Nadu, India, collects, uses, stores and protects your personal information when you visit zentrafoods.in, place an order, or contact us."
      sections={[
        {
          heading: "1. Information We Collect",
          list: [
            "Contact and identity details you provide: name, phone number, email address and shipping address (for orders and enquiries).",
            "Order information: products purchased, order value, payment method and order status.",
            "Payment information: online payments are processed securely by our payment gateway, PayU. We never see, collect or store your card numbers, UPI PINs, net-banking credentials or other sensitive payment data.",
            "Communications: messages you send us via the contact form, email or WhatsApp.",
            "Usage data: pages visited, device and browser information, and interactions with our site, collected via cookies and analytics or advertising tools (such as the Meta/Facebook Pixel, when enabled) [REVIEW].",
          ],
        },
        {
          heading: "2. How We Use Your Information",
          list: [
            "To process, fulfil and deliver your orders, and to communicate order updates via email, SMS or WhatsApp.",
            "To respond to your enquiries and provide customer support.",
            "To send marketing communications or offers, only where you have opted in [REVIEW].",
            "To analyse site usage and improve our products, website and customer experience.",
            "To comply with legal, tax and accounting obligations.",
          ],
        },
        {
          heading: "3. Sharing of Information",
          paragraphs: [
            "We do not sell, rent or trade your personal information. We share it only with:",
          ],
          list: [
            "Courier and fulfilment partners, to deliver your orders.",
            "Payment gateway providers (PayU), to process your payments securely.",
            "Email and messaging service providers, to send you transactional or opted-in communications.",
            "Government or legal authorities, where required by law or to protect our legal rights.",
          ],
        },
        {
          heading: "4. Cookies & Tracking",
          paragraphs: [
            "Our website uses cookies and similar technologies for essential functionality (such as keeping your shopping cart, which is stored in your browser's local storage) and, when enabled, for analytics and advertising measurement [REVIEW]. You can control or delete cookies through your browser settings, though some site features may not work correctly without them.",
          ],
        },
        {
          heading: "5. Data Security",
          paragraphs: [
            "We implement reasonable technical and organisational measures to protect your personal information against unauthorised access, loss or misuse. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.",
          ],
        },
        {
          heading: "6. Data Retention",
          paragraphs: [
            "We retain your personal information for as long as necessary to fulfil your orders, provide support and meet our legal, accounting and regulatory obligations [REVIEW], after which it is securely deleted or anonymised.",
          ],
        },
        {
          heading: "7. Your Rights",
          paragraphs: [
            "You may request access to, correction of, or deletion of your personal information held by us, and you may withdraw consent to marketing communications at any time, by contacting us using the details below.",
          ],
        },
        {
          heading: "8. Grievance Officer",
          paragraphs: [
            "In accordance with the Information Technology Act, 2000 and rules made thereunder, the Grievance Officer for this website is: [REVIEW: name and designation]. You may reach the Grievance Officer at info@zentrafoods.in or +91 90031 40803. We aim to acknowledge grievances within 24 hours and resolve them within 30 days [REVIEW].",
          ],
        },
        {
          heading: "9. Changes to This Policy",
          paragraphs: [
            "We may update this Privacy Policy from time to time. The revised version will be posted on this page with an updated “Last updated” date. Continued use of the website after changes are posted constitutes acceptance of the revised policy.",
          ],
        },
      ]}
    />
  </>
);

export default PrivacyPolicy;
